<template>
  <div class="password-checker--wrap">
    <div v-if="title" class="title">
      {{ title }}
    </div>
    <form class="checker-box" @submit.prevent="onSubmit">
      <div class="checker-content">
        <content-box class="checker-content-box"
          width="460px">
          <i class="icon icon--reset-password"></i>
          <div class="checker-title">{{ $t('userInfo.passwordChecker.title') }}</div>
          <div class="checker-desc" v-html="$t('userInfo.passwordChecker.desc')"></div>
          <ui-input-text class="password-input"
            type="password"
            id="passwordCheckerPassword"
            name="passwordCheckerPassword"
            :modelError="modelError.password"
            :placeholder="$t('common.password')"
            @onFocus="modelError.password = ''"
            @input="model.password = $event">
            {{ $t('common.password') }}
          </ui-input-text>
        </content-box>
        <ui-button class="btn-confirm" primary
          buttonType="submit">
          {{ $t('common.confirm') }}
        </ui-button>
      </div>
    </form>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { parse, addMinutes } from 'date-fns'
import { parseJwt } from '@/libs/utils'
import { myInfoLogin } from '@/api/user'
import { getDialog } from '@/libs/vue-utils'
import ContentBox from '@/components/ui/ContentBox'
import UiInputText from '@/components/ui/UiInputText'
import UiButton from '@/components/ui/UiButton'

const openDialog = getDialog('dialogType')

export default {
  name: 'PasswordChecker',
  components: {
    ContentBox,
    UiInputText,
    UiButton
  },
  data () {
    return {
      model: {
        password: ''
      },
      modelError: {
        password: ''
      }
    }
  },
  computed: {
    ...mapState([
      'userData'
    ]),
    title () {
      switch (this.$route.name) {
        case 'managePlan':
          return this.$t('userInfo.lnb.managePlan')
        case 'billing':
          return this.$t('userInfo.lnb.billing')
        case 'myInformation':
          return this.$t('userInfo.lnb.myInformation')
        default:
          return null
      }
    }
  },
  methods: {
    ...mapMutations([
      'setMyInfoTimestamp'
    ]),
    onSubmit () {
      const password = this.model.password.trim()

      if (!password.length) {
        this.modelError.password = 'requiredPassword'
        return
      }

      myInfoLogin(this.userData.userId, password).then(data => {
        const tokenData = parseJwt(data.accessToken)
        const authDate = parse(tokenData.identity.auth_time * 1000)
        const expireTimestamp = addMinutes(authDate, 30).getTime()
        this.setMyInfoTimestamp(expireTimestamp)
      }).catch(err => {
        this.setMyInfoTimestamp(null)
        switch (err.message) {
          case 'user id not found':
            this.modelError.password = 'notFoundId'
            return
          case 'Unactivated user':
            this.modelError.password = 'unActivatedId'
            return
          case 'Unable user':
            this.modelError.password = 'unAbleId'
            return
          case 'Wrong password':
            this.modelError.password = 'wrongPassword'
            return
        }

        if (!err.isHandled) {
          openDialog('common.error')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.password-checker--wrap {
  position: relative;
  float: left;
  width: calc(100% - 211px);
  padding-top: 40px;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;

  .title {
    font-size: 26px;
    font-weight: 500;
    color: #444444;
    margin-left: 30px;
    margin-right: 30px;
    padding-bottom: 22px;
    padding-left: 10px;
    border-bottom: 1px solid #d7d7d7;
  }

  .checker-box {
    position: absolute;
    width: 100%;
    min-height: 870px;
    left: 0;
    top: 0;
    bottom: 0;
  }

  .checker-content {
    width: 460px;
    @include positionXYcenter;
    top: 45%;
    text-align: center;
  }
  .checker-content-box {
    padding: 25px 25px 50px 25px;
    box-sizing: border-box;

    .icon--reset-password {
      margin-top: 25px;
    }
    .checker-title {
      font-size: 20px;
      font-weight: 600;
      padding: 13px 0 23px 0;
    }
    .checker-desc {
      margin-bottom: 8px;
      line-height: 1.43;
      border-radius: 5px;
      border: solid 1px #ff8400;
      background-color: rgba(255, 132, 0, 0.04);
      padding: 25px 0;
      font-size: 14px;
      color: #2f2f2f;

      /deep/ strong {
        color: #ec0047;
        font-weight: 600;
      }
    }
  }
  .btn-confirm {
    margin-top: 30px;
  }
}

</style>
